import React, { useState } from "react";

const CreateOptions = ({
  option,
  selectedOptions,
  onCheckboxChange,
  bgColor,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    onCheckboxChange(option.id, isChecked);
  };

  const handleDivClick = () => {
    onCheckboxChange(option.id, !isOptionSelected);
  };

  const isOptionSelected =
    selectedOptions && selectedOptions.includes(option.id);

  return (
    <div key={option.id} className="cursor-pointer">
      <fieldset
        className="rounded-[10px] mb-3 md:mb-[14px]"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <legend className="sr-only">Notifications</legend>
        <div className="divide-y divide-gray-200">
          <div
            style={{ backgroundColor: bgColor && bgColor }}
            className={`form-group relative flex items-start py-3 md:py-[17px] px-[14px] md:px-5 border-[1.5px] rounded-[10px] transition-all duration-300 ease-in cursor-pointer hover:bg-[#EBF7FF] service-enrollment ${
              isOptionSelected
                ? "border-primary border-[1.5px]"
                : "border-[#CCD0D4]"
            }`}
            onClick={handleDivClick}
          >
            <div className="flex items-center relative top-[5px]">
              <input
                id={`option-${option.id}`}
                aria-describedby="comments-description"
                name={`option-${option.id}`}
                type="checkbox"
                checked={isOptionSelected}
                onChange={handleCheckboxChange}
                className="rounded border border-solid border-[#CCD0D4] relative cursor-pointer inline-block w-4 md:w-5 h-4 md:h-5 leading-[0px]"
              />
            </div>
            <div className="min-w-0 flex-1 text-sm leading-6">
              <label className="font-medium text-customGray text-base md:text-lg leading-[160%] pl-[14px] cursor-pointer">
                {option.text}
              </label>
              {option.description && (
                <p
                  id="comments-description"
                  className={`text-customGray text-base leading-[160%] font-normal pl-[14px] transition-height duration-300 ease-in ${
                    isHovered ? "max-h-[200px]" : "max-h-[0]"
                  } overflow-hidden`}
                >
                  {option.description}
                </p>
              )}
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default CreateOptions;
